import { Header } from "components/Header/Header";
import { observer } from "mobx-react-lite";
import {
  Box,
  Button,
  Container,
  Message,
  Section,
  Table,
} from "react-bulma-components";
import { joinRoom } from "socket/events/joinRoom";
import { store } from "store/store";
import { getRandomRoomName } from "utils/getRandomRoomName";
import { useI18n } from "i18n/I18nProvider";
import { getPlayerDisplayName } from "utils/getPlayerDisplayName";

export const Results = observer(() => {
  const { locale, t, formatDescriptor } = useI18n();
  return (
    <>
      <Header
        title={store.currentRoom}
        onBack={() => {
          store.setCurrentRoom(null);
        }}
      />
      <Section>
        <Container>
          <Box>
            <Table.Container>
              <Table size="fullwidth">
                <thead>
                  <tr>
                    <th>{t("results.player")}</th>
                    <th>{t("results.score")}</th>
                  </tr>
                </thead>
                <tbody>
                  {store.gameState.results.map((result) => {
                    const player = store.players.find(
                      (p) => p.id === result.playerId,
                    );
                    return (
                      <tr key={result.playerId}>
                        <td>
                          {getPlayerDisplayName(locale, player?.meta.name)}
                        </td>
                        <td>{result.score}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Table.Container>
            {store.gameState.additionalResults.length > 0 && (
              <Message>
                <Message.Body>
                  {t("results.additional")}
                  {store.gameState.additionalResults.map((result, index) => {
                    return <div key={index}>{formatDescriptor(result)}</div>;
                  })}
                </Message.Body>
              </Message>
            )}
            <Button
              color="primary"
              fullwidth
              onClick={() => {
                joinRoom(getRandomRoomName());
              }}
            >
              {t("results.startNewGame")}
            </Button>
          </Box>
        </Container>
      </Section>
    </>
  );
});
